// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuContainer_wrapper__4uy9+","groups":"MenuContainer_groups__rB4x0","facets":"MenuContainer_facets__1KT6O"};